export default function(str, regex){
    if(!(typeof regex instanceof RegExp)){
        regex = new RegExp(regex, "g");
    }
    return regex.test(str);
}
